
  import ScreenSize from '@/mixins/ScreenSize';
  import {prepareImageUrl} from '@/helper/ImageHelper';

  export default {
    name: 'SectionLandingPageHero',
    components: {
      TopBarButtons: () => import('@/components/TopBarButtons'),
      RegistrationOrLoginDialog: () =>
        import('@/components/candidate/RegistrationOrLoginDialog'),
      RichText: () => import('@/components/elements/RichText'),
    },
    mixins: [ScreenSize],
    provide: {
      theme: {isDark: true},
    },
    props: {
      section: {
        type: Object,
        required: false,
        default: () => {},
      },
    },
    data() {
      return {
        height: 0,
        minHeight: 0,
        imageUrl: require(process.env.NUXT_ENV_FALLBACK_MEDIUM_HERO_IMAGE),
      };
    },
    created() {
      const imageUrl = this.section.image
        ? this.isMobile &&
          this.section.image.formats.medium &&
          this.section.image.formats.medium.url
          ? this.section.image.formats.medium.url
          : this.section.image.url
        : false;

      if (imageUrl) {
        this.imageUrl = prepareImageUrl(imageUrl);
      }
    },
    mounted() {
      this.updateHeight();
      window.addEventListener('resize', this.updateHeight);
      this.minHeight = window.innerHeight - 90;
    },
    unmounted() {
      window.removeEventListener('resize', this.updateHeight);
    },
    methods: {
      scrollTo(hash) {
        if (hash) {
          if (hash.length > 1) {
            const id = hash.substring(1);
            const element = document.getElementById(id);
            if (element) element.scrollIntoView({behavior: 'smooth'});
          }
        }
      },
      updateHeight() {
        const customHeight = this.section.height
          ? this.section.height
          : window.innerHeight - 100;
        this.height = this.isMobile ? window.innerHeight - 90 : customHeight;
      },
    },
  };
